import useI18n from '@/composables/use-i18n'
import { SortMethod } from '@/classes/SearchFilter'

export default function () {
  const i18n = useI18n()
  const sortMethodValueNameMap: { [value in SortMethod]: string } = {
    distanceAsc: String(i18n.t('sortMethod.distanceAsc')),
    distanceDesc: String(i18n.t('sortMethod.distanceDesc')),
    priceAsc: String(i18n.t('sortMethod.priceAsc')),
    priceDesc: String(i18n.t('sortMethod.priceDesc')),
    ratingDesc: String(i18n.t('sortMethod.ratingDesc')),
    rankDesc: String(i18n.t('sortMethod.rankDesc')),
  }

  const getSortMethodName = (value: SortMethod | null): string => {
    if (!value) return String(i18n.t('sortMethod.label'))
    return sortMethodValueNameMap[value]
  }

  const list = ([
    'distanceAsc',
    'distanceDesc',
    'priceAsc',
    'priceDesc',
    'ratingDesc',
    'rankDesc',
  ] as SortMethod[]).map(value => ({
    value,
    name: getSortMethodName(value),
  }))

  return {
    getSortMethodName,
    list,
  }
}
